"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CampaignEvents = void 0;
class CampaignEvents {
    builder;
    constructor(builder) {
        this.builder = builder;
    }
    static campaign(builder) {
        return new CampaignEvents(builder);
    }
    addPart(part) {
        this.builder.addPart(part);
        return this;
    }
    toString() {
        return this.builder.toString();
    }
    get create() {
        return this.builder.addPart("create").toString();
    }
    get wildcard() {
        return this.builder.wildcard;
    }
}
exports.CampaignEvents = CampaignEvents;
